module.exports = __webpack_public_path__ + "static/media/agriculture.974148d5.png";